import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { initializeCsrf, makeApiRequest, RequestStatus, unsetCsrfToken } from '../../api_request/api_request';
import { RequestStatusDisplay, Valid } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { email_pattern, username_pattern } from './UserRegistrationForm';
import { loginActions } from "../login/slice";
import { GetPageTitle } from '../../ErnotsConfig';

export function UserSettings()
{
    const appDispatch = useAppDispatch();

    //Let's make super sure we're logged in.
    useEffect(() => {initializeCsrf(appDispatch)}, [appDispatch]);

    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [currentPassword2, setCurrentPassword2] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [re_password, setRePassword] = useState('');
    
    const currentUser = useAppSelector((state) => state.login.currentUser);
    useEffect(function()
    {
        setUsername(currentUser.username || '');
        setEmail(currentUser.email || '');
    }, [currentUser.username, currentUser.email]);

    const [requestUser, setRequestUser] = useState<RequestStatus|undefined>(undefined);
    const [requestPassword, setRequestPassword] = useState<RequestStatus|undefined>(undefined);

    const formValid = (
    {
        username_pattern: username_pattern.test(username),
        email_pattern: email_pattern.test(email),
        passwords_match: newPassword === re_password,
    });

    function validate(type: string)
    {
        if (type === 'user')
        {
            return formValid.username_pattern && formValid.email_pattern;
        }
        if (type === 'password')
        {
            return formValid.passwords_match;
        }

        return true;
    }

    async function handleUpdateUser(event: React.FormEvent)
    {
        event.preventDefault();

        if (!validate('user') || !window.confirm('Update user?'))
        {
            return;
        };
        
        const userData = { email, username, current_password: currentPassword };
        const status = await makeApiRequest({
            endpoint: 'update_username_email/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequestUser
        });

        if (status.success)
        {
            const respData = JSON.parse(status?.responseText || '{}');
            appDispatch(loginActions.setCurrentUserName(respData?.user.username || ''));
            appDispatch(loginActions.setCurrentUserEmail(respData?.user.email || ''));
        }
    };

    async function handleUpdatePassword(event: React.FormEvent)
    {
        event.preventDefault();

        if (!validate('password') || !window.confirm('Update password?'))
        {
            return;
        };
        
        const userData = {new_password: newPassword, current_password: currentPassword2};
        const status = await makeApiRequest({
            endpoint: 'update_password/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequestPassword
        });

        if (status.success)
        {
            //We just got logged out and back in.
            unsetCsrfToken();
        }
    };

    const ret = (
        <div>
            <h2>User Settings</h2>
            <form onSubmit={handleUpdateUser}>
                <legend>Update User</legend>
                <fieldset>
                    <div>
                        <label>Current Password</label>
                        <Input
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required />
                        <Valid bValid={currentPassword.trim()} children="Your current password is required."/>
                    </div>
                    <div>
                        <label>Username</label>
                        <Input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required />
                        <Valid bValid={formValid.username_pattern} children='A username is required.'/>
                    </div>
                    <div>
                        <label>Email</label>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required />
                        <Valid bValid={formValid.username_pattern} children='An email address is required.'/>
                    </div>
                    <Button type='submit'>Save Changes</Button>
                    <RequestStatusDisplay request={requestUser}/>
                </fieldset>
            </form>

            <form onSubmit={handleUpdatePassword}>
                <fieldset>
                    <legend>Update Password</legend>
                    <div>
                        <label>Current Password</label>
                        <Input
                            type="password"
                            value={currentPassword2}
                            onChange={(e) => setCurrentPassword2(e.target.value)}
                            required />
                        <Valid bValid={currentPassword2.trim()} children="Your current password is required."/>
                    </div>
                    <div>
                        <label>New Password</label>
                        <Input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required />
                        <Valid bValid={newPassword.trim()} children="A new password is required."/>
                    </div>
                    <div>
                        <label>Retype Password</label>
                        <Input
                            type="password"
                            value={re_password}
                            onChange={(e) => setRePassword(e.target.value)}
                            required />
                        <Valid bValid={formValid.passwords_match} children="The confirmation password doesn't match."/>
                    </div>
                    <Button type='submit'>Change Password</Button>
                    <RequestStatusDisplay request={requestPassword}/>
                </fieldset>
            </form>
        </div>
    );

    return (
    <div className='ernots_User ernots_UserSettings'>
        <title>{GetPageTitle('User Settings')}</title>
        {ret}
    </div>);
};